import React, { useState, useEffect } from 'react';

const links = [
	{ href: '#about', label: 'About' },
	{ href: '#education', label: 'Education' },
	{ href: '#work-experience', label: 'Work' },
	{ href: '#projects', label: 'Projects' },
	{ href: '#tech', label: 'Technologies' },
	{ href: '#contact', label: 'Contact' },
];

export default function NavBar() {
	const [isOpen, setIsOpen] = useState(false);
	const [scrolled, setScrolled] = useState(false);

	useEffect(() => {
		const onScroll = () => setScrolled(window.scrollY > 24);
		window.addEventListener('scroll', onScroll, { passive: true });
		return () => window.removeEventListener('scroll', onScroll);
	}, []);

	const scrollTo = (e, href) => {
		e.preventDefault();
		const el = document.querySelector(href);
		if (el) {
			const offset = el.getBoundingClientRect().top + window.scrollY - 68;
			window.scrollTo({ top: offset, behavior: 'smooth' });
		}
		setIsOpen(false);
	};

	return (
		<nav className={`navbar${scrolled ? ' scrolled' : ''}`}>
			<div className="navbar-inner">
				<a
					href="#about"
					className="navbar-logo"
					onClick={(e) => scrollTo(e, '#about')}
				>
					NL
				</a>

				<div className="navbar-links">
					{links.map(({ href, label }) => (
						<a key={href} href={href} onClick={(e) => scrollTo(e, href)}>
							{label}
						</a>
					))}
				</div>

				<button
					className="hamburger-btn"
					onClick={() => setIsOpen((o) => !o)}
					aria-label={isOpen ? 'Close menu' : 'Open menu'}
					aria-expanded={isOpen}
				>
					<svg
						width="20"
						height="20"
						viewBox="0 0 20 20"
						fill="none"
						stroke="#9099b0"
						strokeWidth="1.8"
						strokeLinecap="round"
					>
						{isOpen ? (
							<>
								<line x1="4" y1="4" x2="16" y2="16" />
								<line x1="16" y1="4" x2="4" y2="16" />
							</>
						) : (
							<>
								<line x1="3" y1="5" x2="17" y2="5" />
								<line x1="3" y1="10" x2="17" y2="10" />
								<line x1="3" y1="15" x2="17" y2="15" />
							</>
						)}
					</svg>
				</button>
			</div>

			<div className={`mobile-menu${isOpen ? ' open' : ''}`}>
				{links.map(({ href, label }) => (
					<a key={href} href={href} onClick={(e) => scrollTo(e, href)}>
						{label}
					</a>
				))}
			</div>
		</nav>
	);
}
